import { NavLink } from "react-router-dom";

export const SubHeader = ({ children }) => {

    return (
        <div
            className="d-flex w-100 border-bottom align-items-center bg-white position-sticky top-0"
            style={{
                minHeight: "58px",
                zIndex: 1
            }}
        >
            {children}
        </div>
    )
}

const SubHeaderNav = ({ children }) => {
    return (
        <nav
            style={{
                padding: "10px 16px",
                minHeight: "58px",
                overflowX: "auto",
                overflowY: "hidden",
                whiteSpace: "nowrap"
            }}
            className={"col d-flex align-items-center"}
        >
            {children}
        </nav>
    )
}

const SubHeaderNavItem = ({ label, to }) => {
    return (
        <NavLink
            to={to || "#"}
            style={
                isActive => ({
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "8px 14px",
                    marginRight: "8px",
                    borderRadius: "999px",
                    fontWeight: isActive ? 600 : 500,
                    fontSize: "12px",
                    lineHeight: 1,
                    color: isActive ? "#ffffff" : "#5E6278",
                    backgroundColor: isActive ? "#22A455" : "#F3F6F9",
                    border: isActive ? "1px solid #22A455" : "1px solid #E4E6EF",
                    boxShadow: isActive ? "0 6px 16px rgba(34, 164, 85, 0.18)" : "none",
                    transition: "all 0.2s ease",
                })
            }
            className={"text-decoration-none"}
        >
            {label}
        </NavLink>
    )
}

const SubHeaderActions = ({ children }) => {
    return (
        <div
            style={{
                backgroundColor: "black",
                padding: "14px 16px",
            }}
            className={"d-flex h-100 text-white"}
        >
            {children}
        </div>
    )
}

SubHeader.Actions = SubHeaderActions
SubHeader.Nav = SubHeaderNav
SubHeader.NavItem = SubHeaderNavItem
